import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { c as i } from "../../../../clsx-OuTLNxxd.js";
import { u as L } from "../../../../downshift.esm-DOYNj0ZE.js";
import { I as l } from "../../../../icon-OnwLrJ7B.js";
import "../../icon/iconsList.js";
import { AlternativeAction as M } from "./alternativeAction/alternativeAction.js";
const O = "_disabled_4nucc_43", q = "_highlight_4nucc_112", e = {
  "autocomplete-container": "_autocomplete-container_4nucc_1",
  "input-container": "_input-container_4nucc_10",
  "has-error": "_has-error_4nucc_19",
  "label-helper-text": "_label-helper-text_4nucc_22",
  "input-block": "_input-block_4nucc_27",
  disabled: O,
  "error-text": "_error-text_4nucc_81",
  "suggestions-container": "_suggestions-container_4nucc_90",
  highlight: q,
  "item-block": "_item-block_4nucc_115",
  "no-suggestion": "_no-suggestion_4nucc_126",
  "alternative-action-container": "_alternative-action-container_4nucc_129"
}, Q = ({
  onChange: o,
  onSelect: u,
  noSuggestionText: x,
  suggestions: t = [],
  initialValue: g,
  placeholder: p,
  label: _,
  labelHelperText: h,
  alternativeAction: d,
  href: f,
  openNewTab: k,
  onAlternativeAction: I,
  inputIcon: v,
  itemsIcon: s,
  disabled: b,
  hasError: m,
  errorText: z
}) => {
  const { isOpen: P, getLabelProps: V, getInputProps: j, getMenuProps: y, getItemProps: A, highlightedIndex: w, inputValue: N } = L({
    onInputValueChange({ inputValue: c }) {
      o == null || o(c);
    },
    items: t,
    itemToString(c) {
      return (c == null ? void 0 : c.value) ?? "";
    },
    onSelectedItemChange(c) {
      var n;
      u == null || u(((n = c.selectedItem) == null ? void 0 : n.value) ?? "");
    },
    initialInputValue: g
  });
  return /* @__PURE__ */ a("div", { className: e["autocomplete-container"], children: [
    /* @__PURE__ */ a("div", { className: e["input-container"], children: [
      _ && /* @__PURE__ */ r("label", { className: i(m && e["has-error"]), ...V(), children: _ }),
      _ && h && /* @__PURE__ */ r("div", { className: e["label-helper-text"], children: h }),
      /* @__PURE__ */ a("div", { className: e["input-block"], children: [
        v && /* @__PURE__ */ r(l, { className: i(b && e.disabled), name: v, size: "large" }),
        /* @__PURE__ */ r(
          "input",
          {
            className: i(m && e["has-error"]),
            type: "text",
            ...p && { placeholder: p },
            ...j({ disabled: b })
          }
        )
      ] }),
      m && /* @__PURE__ */ a("div", { className: e["error-text"], children: [
        /* @__PURE__ */ r(l, { name: "error-warning-fill", size: "large", color: "error" }),
        z
      ] })
    ] }),
    /* @__PURE__ */ r("div", { ...y(), children: P && t && N && /* @__PURE__ */ a("div", { className: e["suggestions-container"], children: [
      /* @__PURE__ */ a("ul", { children: [
        t == null ? void 0 : t.map((c, n) => /* @__PURE__ */ a(
          "li",
          {
            className: i(s && e["item-block"], w === n && e.highlight),
            ...A({ item: c, index: n }),
            children: [
              s && /* @__PURE__ */ r(l, { name: s, size: "large" }),
              c.value
            ]
          },
          c.id
        )),
        (t == null ? void 0 : t.length) === 0 && /* @__PURE__ */ r("li", { className: e["no-suggestion"], children: x })
      ] }),
      d && /* @__PURE__ */ a("div", { className: e["alternative-action-container"], children: [
        /* @__PURE__ */ r(l, { name: "pencil", size: "large", color: "eco-green" }),
        /* @__PURE__ */ r(
          M,
          {
            alternativeAction: d,
            href: f,
            openNewTab: k,
            onAlternativeAction: I,
            value: N
          }
        )
      ] })
    ] }) })
  ] });
};
export {
  Q as Autocomplete
};
